import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './FiltersForm.css'
import ActionLink from "../../../../controls/ActionLink";

class FiltersForm extends Component {
    static propTypes = {
        onChange: PropTypes.func.isRequired
    };
    static defaultProps = {};
    state = {
        url: '',
        userName: ''
    };

    render() {
        return (
            <div className="panel box" role="mongodb-filters-form">
                <div className="box-row">
                    <div className="box-cell p-x-2 p-y-1 bg-black text-xs-center font-size-11 font-weight-semibold">
                        <i className="fa fa-filter"/>&nbsp;&nbsp;Фильтры
                    </div>
                </div>
                <div className="box-row">
                    <form className="panel-body">
                        <fieldset className="form-group">
                            <label htmlFor="mongodb-filter-url">URL</label>
                            <input type="text" className="form-control"
                                   id="mongodb-filter-url"
                                   value={this.state.url}
                                   onChange={event => this.setUrl(event.target.value)}/>
                        </fieldset>
                        <fieldset className="form-group">
                            <label htmlFor="mongodb-filter-userName">Имя пользователя</label>
                            <input type="text" className="form-control"
                                   id="mongodb-filter-userName"
                                   value={this.state.userName}
                                   onChange={event => this.setUserName(event.target.value)}/>
                        </fieldset>
                    </form>
                </div>
                <div className="box-row">
                    <ActionLink className="widget-more-link"
                                onClick={() => this.reset()}>
                        СБРОСИТЬ
                    </ActionLink>
                </div>
            </div>
        );
    }

    setUrl(value) {
        const newState = {
            url: value,
            userName: this.state.userName
        };

        this.setState({url: value});
        this.props.onChange(newState);
    }

    setUserName(value) {
        const newState = {
            url: this.state.url,
            userName: value
        };

        this.setState({userName: value});
        this.props.onChange(newState);
    }

    reset() {
        const newState = {
            url: '',
            userName: ''
        };

        this.setState(newState);
        this.props.onChange(newState);
    }
}

export default FiltersForm;


// WEBPACK FOOTER //
// ./src/pages/Developers/MongoDbProfiler/components/FiltersForm.js